<template>
  <v-list nav dense class="program-list-group" id="ProgramListGroup">
    <!-- <v-list-item v-if="isPrinterEnabled">
      <v-list-item-content class="program-list-printer-item" id="ProgramListPrinterItem">
        <v-switch
          id="programListPrinterSwitch"
          class="mt-0 pt-0 ml-4 program-list-printer-switch"
          inset
          hide-details
          v-model="printerMode"
          :label="printerMode ? 'Printer' : 'Preview'"
          @change="togglePrinterMode"
        ></v-switch>
      </v-list-item-content>
    </v-list-item> -->
    <!-- <v-divider></v-divider> -->
    <template v-if="hasValidToken">
    <v-list-item-group
      v-for="(item, index) in menuItems"
      :key="index"
      :id="`menuItemGroup-${index}`"
      class="program-list-item-group"
    >
      <!-- program list items which have subitems -->
      <template v-if="item.children">
        <v-list-item
          v-if="applyAuth(item.authCondition)"
          link
          @click="toggleItem(index)"
          class="program-list-item has-children"
          :id="item.linkId || `menuItem-${index}`"
        >
          <v-icon>{{ item.icon }}</v-icon>
          <v-list-item-title :to="resolvePath(item)">
            {{ item.text }}
          </v-list-item-title>
          <v-list-item-action>
            <v-icon>{{ item.expanded ? icons.mdiMenuUp : icons.mdiMenuDown }}</v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
      <!-- program list items which does not have subitems -->
      <template v-else>
        <v-list-item
          v-if="applyAuth(item.authCondition)"
          :to="resolvePath(item)"
          link
          class="program-list-item no-children"
          :id="item.linkId || `menuItem-${index}`"
        >
          <v-icon> {{ item.icon }} </v-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </template>
      <!-- subitems or child items of the program list -->
      <template v-if="item.children && item.expanded">
        <template v-for="(child, childIndex) in item.children">
          <v-list-item
            v-if="applyAuth(child.authCondition)"
            :key="childIndex"
            :to="resolvePath(child)"
            class="program-child-item"
            :id="child.linkId || `childItem-${index}-${childIndex}`"
          >
            <v-icon> {{ child.icon }} </v-icon>
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item>
        </template>
      </template>

    </v-list-item-group>
    </template>
    <!-- help / support -->
    <v-list-item
      id="programListHelpSupport"
      class="program-auth-item"
      @click="openHelpSupport"
    >
      <v-icon>{{ icons.mdiLifebuoy }}</v-icon>

      <v-list-item-title>SUPPORT PORTAL<v-chip v-if="supportUnreadCount > 0" x-small color="blue darken-1" dark class="support-badge-chip">{{ supportUnreadCount }}</v-chip></v-list-item-title>

    </v-list-item>
    <!-- login and logout  -->
    <v-list-item
      id="programListLogout"
      class="program-auth-item"
      @click="logout"
      v-if="authUser !== 'anonymous'"
    >
      <v-icon>{{ icons.mdiShieldLockOutline }}</v-icon>
      <v-list-item-title>Logout (as {{ authUser }})</v-list-item-title>
    </v-list-item>
    <v-list-item
      id="programListLogin"
      @click="login"
      v-if="authUser === 'anonymous'"
      class="program-auth-item"
    >
    <v-icon>{{ icons.mdiShieldLockOutline }}</v-icon>
    <v-list-item-title>Login</v-list-item-title>
    </v-list-item>

  </v-list>
</template>

<script>
import {
  mdiHome,
  mdiBankTransfer,
  mdiFileImport,
  mdiAccount,
  mdiApplicationCog,
  mdiAccountCog,
  mdiShieldLockOutline,
  mdiTableArrowRight,
  mdiEqualBox,
  mdiNote,
  mdiReceipt,
  mdiBankTransferOut,
  mdiFileDocumentMultiple,
  mdiBookOpen,
  mdiMenuDown,
  mdiMenuUp,
  mdiBook,
  mdiBookCog,
  mdiBookSettingsOutline,
  mdiAlphaTBox,
  mdiAccountCashOutline,
  mdiCommentProcessingOutline,
  mdiArrowDecision,
  mdiTextSearch,
  mdiImageAutoAdjust,
  mdiPageNextOutline,
  mdiFolderStarOutline,
  mdiSwapVertical,
  mdiFolderAlertOutline,
  mdiHelpCircle,
  mdiLifebuoy,
} from '@mdi/js';
import {
  mapGetters,
  mapActions,
  mapState,
} from 'vuex';
import { isCanadian } from '../../util/shared/county-specific.config';
import { setPrinterMode, getPrinterConfig } from '../../util/pdf-to-printer.util';
import { getRawJwt } from '../../util/jwt';
import { clients } from '../../util/clients';
import { createActivityTracker } from '../../util/idle-activity';

export default {
  name: 'ProgramList',
  data: () => ({
    printerMode: false, // Default to Preview
    isPrinterEnabled: false, // Default to Turning off printer mode
    supportUnreadCount: 0,
    supportPollInterval: null,
    activityTracker: null,
    idleCheckInterval: null,
    activityHandler: null,
    menuItems: [
      {
        text: 'Home',
        pathName: 'Home',
        icon: mdiHome,
        linkId: 'programListHome',
      },

      {
        text: 'Bookkeeping',
        icon: mdiBookSettingsOutline,
        children: [
          {
            text: 'General Ledger',
            pathName: 'General Ledger - Transactions',
            icon: mdiBookOpen,
            linkId: 'programListGl',
            authCondition: 'isGlAccessible',
          },
          {
            text: 'Miscellaneous Receipts',
            pathName: 'Miscellaneous Receipts - Transactions',
            icon: mdiReceipt,
            linkId: 'programListMisc',
            authCondition: 'isMiscAccessible',
          },
          {
            text: 'Mortgage Tax',
            pathName: 'Mortgage Tax - Transactions',
            icon: mdiBankTransferOut,
            linkId: 'programListMtg',
            authCondition: 'isMtgAccessible',
          },
          {
            text: 'Official Depository',
            pathName: 'Official Depository - Deposits & Vouchers',
            icon: mdiBankTransfer,
            linkId: 'programListOD',
            authCondition: 'isODAccessible',
          },
          {
            text: 'Payroll Register',
            path: '/payroll/transactions',
            icon: mdiBook,
            linkId: 'programListWar',
            authCondition: 'isWarAccessible && isPayrollRegisterProgram',
          },
          {
            text: 'Warrants & Appropriations',
            path: '/war/transactions',
            icon: mdiEqualBox,
            linkId: 'programListWar',
            authCondition: 'isWarAccessible',
          },
        ],
      },
      {
        text: 'Tax',
        icon: mdiAlphaTBox,
        children: [
          {
            text: 'Tax Inquiry',
            pathName: 'Tax - Tax Inquiry - Tax Roll',
            icon: mdiTextSearch,
            authCondition: 'isTaxAccessible',
          },
          {
            text: 'Payments',
            path: '/tax/payments/dashboard',
            icon: mdiAccountCashOutline,
            authCondition: 'isPaymentsAccessible',
          },
          {
            text: 'Adjustments',
            path: '/tax/adjustments/adjustmentssearch',
            icon: mdiImageAutoAdjust,
            authCondition: 'isAjustmentAccessible',

          },
          {
            text: 'Mortgage Co Processing',
            path: '/tax/mortgageco/billrequests',
            icon: mdiPageNextOutline,
            authCondition: 'isMortgageCoAccessible',

          },
          {
            text: 'Comments',
            path: '/tax/comments/commentsearch',
            icon: mdiCommentProcessingOutline,
            authCondition: 'isTaxAccessible',

          },
          {
            text: 'TR Work File',
            path: '/tax/trworkfile/createTrWorkFile',
            icon: mdiSwapVertical,
            authCondition: 'isTaxAccessible',
          },
          {
            text: 'Special Tax Items',
            path: '/tax/specialTaxItems/protestedTax',
            icon: mdiFolderStarOutline,
            authCondition: 'isSpecialTaxAccessible',

          },
          {
            text: 'Delinquent Tax',
            path: '/tax/delinquent/juneResale/resalepropertylist',
            icon: mdiFolderAlertOutline,
            authCondition: 'isDelinquentTaxAccessible',
          },
        ],
      },
      {
        text: 'Apportionment',
        path: '/apportionment/taxes',
        icon: mdiArrowDecision,
        authCondition: 'isApportionmentAccessible',
      },
      {
        text: 'Shared Lists',
        pathName: 'Shared Program - Banks',
        icon: mdiTableArrowRight,
        linkId: 'programListShared',
        authCondition: 'isSharedProgAccessible',
      },

      {
        text: 'Import / Export / Backup',
        pathName: 'Import / Export',
        icon: mdiFileImport,
        linkId: 'programListImportExport',
        authCondition: 'isIEBAccessible||isBankProfileAccessible||isAuditorOnly',
      },

      {
        text: 'Administration',
        icon: mdiBookCog,
        children: [
          {
            text: 'Profile',
            pathName: 'Profile',
            icon: mdiAccount,
            linkId: 'programListProfile',
            authCondition: '!isNarrowAdministrationPersona',
          },
          {
            text: 'Settings',
            pathName: 'System Configuration',
            icon: mdiApplicationCog,
            linkId: 'programListSettings',
            authCondition: 'isSysConfigAccessible',
          },
          {
            text: 'User Guides',
            pathName: 'User Guide',
            icon: mdiFileDocumentMultiple,
            linkId: 'programListUserGuide',
          },
          {
            text: 'User Administration',
            pathName: 'User Administration',
            icon: mdiAccountCog,
            linkId: 'programListUserAdministration',
            authCondition: 'isUserAdminAccessible',
          },
          {
            text: 'Audit Log',
            pathName: 'Audit Log',
            icon: mdiNote,
            linkId: 'programListAuditLog',
            authCondition: 'isAuditLogAccessible',
          },
          {
            text: 'Restore Log',
            pathName: 'Restore Log',
            icon: mdiNote,
            linkId: 'programListRestore',
            authCondition: '!isNarrowAdministrationPersona',
          },

        ],
      },
    ],
    icons: {
      mdiMenuDown,
      mdiMenuUp,
      mdiShieldLockOutline,
      mdiHelpCircle,
      mdiLifebuoy,
    },
  }),

  created() {
    this.loadConfig({ requiredScope: 'warconfig' });
    this.loadPrinterConfig();
  },
  mounted() {
    this.fetchSupportUnreadCount();
    this.supportPollInterval = setInterval(() => this.fetchSupportUnreadCount(), 5 * 60 * 1000);

    // Activity is tracked across every tab on the origin, not just this one.
    // See src/util/idle-activity.js (TKT-000727).
    this.activityTracker = createActivityTracker();
    this.activityTracker.mark();
    this.activityHandler = () => { this.activityTracker.mark(); };
    ['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach((evt) => {
      window.addEventListener(evt, this.activityHandler);
    });
    // Check runs on a fixed 30s cadence, so logout can lag up to ~30s past
    // logoutTimePeriod for short configured values.
    // idleMs is how long the USER has been idle in any tab. Measuring only this
    // tab meant a window left open overnight crossed logoutTimePeriod on its own
    // and called logout(), which clears the shared auth keys and signed the user
    // out of the tab they were actually working in - every 30s, all day.
    this.idleCheckInterval = setInterval(() => {
      const idleMs = this.activityTracker.idleMs();
      if (idleMs > this.globalSettingItem.logoutTimePeriod * 1000) {
        this.logout();
      }
    }, 30 * 1000);
  },
  beforeDestroy() {
    if (this.supportPollInterval) clearInterval(this.supportPollInterval);
    if (this.idleCheckInterval) clearInterval(this.idleCheckInterval);
    if (this.activityHandler) {
      ['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach((evt) => {
        window.removeEventListener(evt, this.activityHandler);
      });
    }
  },
  computed: {
    ...mapGetters('auth/token', [
      'authUser',
      'hasValidToken',
      'isODAccessible',
      'isIEBAccessible',
      'isBankProfileAccessible',
      'isMtgAccessible',
      'isSysConfigAccessible',
      'isUserAdminAccessible',
      'isAuditUserAccessible',
      'isWarAccessible',
      'isMiscAccessible',
      'isSharedProgAccessible',
      'isGlAccessible',
      'isPaymentsAccessible',
      'isAjustmentAccessible',
      'isMortgageCoAccessible',
      'isDelinquentTaxAccessible',
      'isSpecialTaxAccessible',
      'isApportionmentAccessible',
      'isTaxAccessible',
      'isAuditorOnly',
      'isNarrowAdministrationPersona',
      'isAuditLogAccessible',
    ]),
    ...mapState({
      warSettingItem: (state) => state.SystemConfig.warSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    isPayrollRegisterProgram() {
      return this.warSettingItem && this.warSettingItem.payrollRegisterProgram;
    },
    payrollProgramName() {
      const { countyName } = this.globalSettingItem;
      if (isCanadian(countyName)) {
        return 'Payroll/School Register';
      }
      return 'Payroll Register';
    },
  },

  methods: {
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions([
      'reAuth',
      'flashError',
    ]),
    logout() {
      this.$store.commit('auth/token/setLoggedOut');
    },
    login() {
      this.$store.commit('auth/token/setLoggedOut');
      this.reAuth();
    },
    toggleItem(index) {
      this.$set(this.menuItems, index, {
        ...this.menuItems[index],
        expanded: !this.menuItems[index].expanded,
      });
    },
    // Apply authnetication to all programs
    applyAuth(authCondition) {
      switch (authCondition) {
        case 'isTaxAccessible':
          return this.isTaxAccessible;
        case 'isPaymentsAccessible':
          return this.isPaymentsAccessible;
        case 'isAjustmentAccessible':
          return this.isAjustmentAccessible;
        case 'isMortgageCoAccessible':
          return this.isMortgageCoAccessible;
        case 'isDelinquentTaxAccessible':
          return this.isDelinquentTaxAccessible;
        case 'isSpecialTaxAccessible':
          return this.isSpecialTaxAccessible;
        case 'isApportionmentAccessible':
          return this.isApportionmentAccessible;
        case 'isODAccessible':
          return this.isODAccessible;
        case 'isWarAccessible':
          return this.isWarAccessible;
        case 'isIEBAccessible||isBankProfileAccessible':
          return this.isBankProfileAccessible || this.isIEBAccessible;
        case 'isMiscAccessible':
          return this.isMiscAccessible;
        case 'isMtgAccessible':
          return this.isMtgAccessible;
        case 'isGlAccessible':
          return this.isGlAccessible;
        case 'isSharedProgAccessible':
          return this.isSharedProgAccessible;
        case 'isSysConfigAccessible':
          return this.isSysConfigAccessible;
        case 'isUserAdminAccessible':
          return this.isUserAdminAccessible;
        case 'isAuditUserAccessible':
          return this.isAuditUserAccessible;
        case 'isWarAccessible && isPayrollRegisterProgram':
          return this.isWarAccessible && this.isPayrollRegisterProgram;
        case 'isAuditorOnly':
          return this.isAuditorOnly;
        case '!isAuditorOnly':
          return !this.isAuditorOnly;
        case '!isNarrowAdministrationPersona':
          return !this.isNarrowAdministrationPersona;
        case 'isAuditLogAccessible':
          return this.isAuditLogAccessible;
        default:
          return true; // Default value when authCondition is not recognized
      }
    },
    // function to resolve path routes
    resolvePath(item) {
      let path = '';
      if (item.pathName) {
        path = { name: item.pathName };
      } else {
        path = { path: item.path };
      }
      return path;
    },
    // function to load printer config
    loadPrinterConfig() {
      const data = getPrinterConfig();
      // console.info('Printer config loaded:', data);
      this.printerMode = data.printerMode || false; // Default to Preview
      this.isPrinterEnabled = data.isPrinterEnabled || false; // Default to turning off printer mode
    },
    // function to set printerMode
    togglePrinterMode() {
      setPrinterMode(this.printerMode);
      // console.info('Printer mode changed to:', this.printerMode);
    },
    async fetchSupportUnreadCount() {
      if (this.authUser === 'anonymous') return;
      try {
        const res = await clients.direct.authRest.get('/support/unread-count');
        this.supportUnreadCount = res.data.count || 0;
      } catch (err) {
        if (err.response && (err.response.status === 401 || err.response.status === 403)) {
          clearInterval(this.supportPollInterval);
          this.supportPollInterval = null;
        }
        console.warn('[ProgramList] fetchSupportUnreadCount failed:', err.message);
        this.supportUnreadCount = 0;
      }
    },
    async openHelpSupport() {
      if (this.authUser === 'anonymous') {
        this.flashError('Please log in to open Help & Support.');
        return;
      }
      const jwt = getRawJwt();
      if (!jwt) {
        this.flashError('Please log in to open Help & Support.');
        return;
      }
      try {
        const res = await clients.direct.authRest.post('/support/access-token');
        const { accessToken, loginUrl } = res.data;
        if (!accessToken || !loginUrl) {
          this.flashError('Failed to get support access.');
          return;
        }
        this.supportUnreadCount = 0;
        window.open(`${loginUrl}?token=${encodeURIComponent(accessToken)}`, '_blank');
      } catch (e) {
        const data = e.response && e.response.data;
        const rawUrl = data && data.loginUrl;
        const allowedOrigins = [
          'https://tm-support.local.tmconsulting.dev',
          'https://tm-support.uat.local.tmconsulting.dev',
        ];
        const safeUrl = rawUrl && allowedOrigins.some((o) => rawUrl.startsWith(o)) ? rawUrl : null;
        if (safeUrl) {
          this.flashError('Opening Help & Support login page...');
          window.open(safeUrl, '_blank');
        } else {
          const msg = (data && data.error) || 'Unable to open Help & Support. Please try again later.';
          this.flashError(msg);
        }
      }
    },
  },
};
</script>

<style scoped>
.support-badge-chip {
  font-size: 9px;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  margin-left: 1px;
  vertical-align: super;
}
</style>
